<template>
    <div class="component" :class="[`type_${object.type} ${object.parentClass || ''}`, { 'maximize': maximize }]" @mouseleave="showMenu=false">
        <div class="menu" :title="$t('designer.objectLoader.menu.open')" v-if="haveMenu" @click="showMenu=true" >
          <i v-if="!showMenu" class="btn fas fa-ellipsis-v"></i>
          <div class="wrapper">
            <transition name="slide">
              <div v-if="showMenu" class="items">
                <i @click.stop="showMenu=false" class="fas fa-times" :title="$t('designer.objectLoader.menu.close')"></i>
                <i @click.stop="maximize=!maximize" :class="{ 'fas fa-expand-alt': !maximize, 'fas fa-compress-alt': maximize }" :title="$t(maximize ? 'designer.objectLoader.menu.minimize' : 'designer.objectLoader.menu.expand')"></i>
                <i v-for="(action, index) in menuActions" :key="index" :class="action.icon" @click.stop="executeAction(action.function)" :title="$t(action.title || '')"/>
              </div>
            </transition>
          </div>
        </div>
        <div class="menu_edition">
          <div>
            <button class="button-primary m-0" type="button" @click="editObject()" :title="$t('designer.objectLoader.edit')">
              <i class="fas fa-edit"></i>
            </button>
            <button class="button-primary m-0" type="button" @click="moveUp()" :title="$t('designer.objectLoader.move.up')">
              <i class="fas fa-chevron-up"></i>
            </button>
          </div>
          <!-- <button class="button-primary m-0" type="button" @click="moveLeft()" :title="$t('designer.objectLoader.move.left')">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button class="button-primary m-0" type="button" @click="moveRight()" :title="$t('designer.objectLoader.move.right')">
            <i class="fas fa-chevron-right"></i>
          </button> -->
          <div>
            <button class="button-primary m-0" type="button" @click="cloneObject()" :title="$t('designer.objectLoader.clone')">
              <i class="fas fa-copy"></i>
            </button>
            <button class="button-primary m-0" type="button" @click="moveDown()" :title="$t('designer.objectLoader.move.down')">
              <i class="fas fa-chevron-down"></i>
            </button>
          </div>
          <div>
            <button class="button-primary m-0" type="button" @click="deleteObject()" :title="$t('designer.objectLoader.delete')">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
        <component v-if="!object.plkNoEdited" v-bind:is="instance" :connection="connection" :plkparams="plkparams" :maximized="maximize"></component>
        <div class="noObject" v-if="object.plkNoEdited">NO EDITED {{object.type}}</div>
    </div>
</template>
<script>
import i18n from './i18n'
export const EDIT_OBJECT = 'editObject'
export const DELETE_OBJECT = 'deleteObject'
export const CLONE_OBJECT = 'cloneObject'
export const MOVE_LEFT = 'leftObject'
export const MOVE_RIGHT = 'rightObject'
export const MOVE_UP = 'upObject'
export const MOVE_DOWN = 'downObject'

export default {
  name: 'ObjectLoader',
  props: {
    instance: {
      required: true
    },
    object: {
      required: true
    },
    position: {
      required: true
    }
  },
  data () {
    return {
      showMenu: false,
      maximize: false
    }
  },
  computed: {
    haveMenu () {
      return (this.object || {}).menu === undefined || Array.isArray((this.object || {}).menu) ? true : this.object.menu
    },
    menuActions () {
      return (this.object || {}).menu && Array.isArray((this.object || {}).menu) ? this.object.menu : []
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    },
    deleteObject () {
      parent.postMessage({ type: DELETE_OBJECT, position: this.position, object: this.object })
    },
    cloneObject () {
      parent.postMessage({ type: CLONE_OBJECT, position: this.position, object: this.object })
    },
    editObject () {
      parent.postMessage({ type: EDIT_OBJECT, position: this.position, object: this.object })
    },
    moveLeft () {
      parent.postMessage({ type: MOVE_LEFT, position: this.position, object: this.object })
    },
    moveRight () {
      parent.postMessage({ type: MOVE_RIGHT, position: this.position, object: this.object })
    },
    moveUp () {
      parent.postMessage({ type: MOVE_UP, position: this.position, object: this.object })
    },
    moveDown () {
      parent.postMessage({ type: MOVE_DOWN, position: this.position, object: this.object })
    },
    executeAction (exec) {
      if (exec) {
        try {
          let fun = new Function(['ctx'], exec)
          return fun.apply(this, [this])
        } catch (e) {
          return exec
        }
      }
    }
  }
}
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.component.maximize {
  position: fixed;
  left: 0;
  top: 0;
  background: white;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  margin: 0px !important;
  z-index: 10;
}
.menu {
  position: absolute;
  display: none;
}
.menu_edition {
  z-index: 999999;
  display: none;
  position: absolute;
  margin: 5px;;
  margin-left: 25px;
  font-size: 16px;
}
.menu_edition .button-primary {
  cursor: pointer;
  line-height: 0px;
  padding: 0px 10px;
  width: 35px;
}
.component:hover .menu,
.component:hover .menu_edition {
  display: inline;
}
@media (hover: none) and (pointer: coarse) {
  .menu,
  .menu_edition {
    display: block;
  }
}
.menu .btn {
  padding-top: .5rem;
  padding-left: 1rem;
  cursor: pointer;
}
.menu .wrapper {
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  z-index: 1;
}
.menu .items {
  background-color: white;
  border: solid #efefef 1px;
  border-bottom: solid #efefef 1px;
  width: 25px;
  padding: 0 10px;
  border-radius: 0 0 20px 0px;
}
.menu .items i {
  margin: 13px 5px 14px;
  color: black;
  font-size: 1em;
  cursor: pointer;
}
.slide-enter-active, .slide-leave-active  {
  transition: all .6s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
button.button-primary {
  color: #FFF;
  background-color: #b5b5b5;
  border-color: #efefef;
}
button.button-primary:hover {
  color: #000;
  background-color: #efefef;
  border-color: #b5b5b5;
}
.component .noObject {
  padding: 5px;
  text-align: center;
  border: 1px solid #dee2e6;
  border-radius: 10px;
  margin-left: 5px;
  margin-right: 5px;
}
</style>
